<template>
	  <span>
    <b-nav v-if="showNav">
      <b-nav-item-dropdown
          id="my-nav-dropdown "
          text="Administration"
          toggle-class="nav-link-custom"
      >
        <template slot="button-content">
          <i class="fa mr-2 fa-lock text-blue" font-scale="1"></i>
          <span>Administration</span>
        </template>
  
        <slot v-for="(item, index) in links" name="title">
          <b-dropdown-item 
            :to="item.link" 
            :title="item.description"
            b-v-tooltip.hover
          >
            <i :class="`${item.icon} pr-2`" :style="{color: item.icon_color}"></i>
            {{ item.name }}
          </b-dropdown-item>
        </slot>
      </b-nav-item-dropdown>
    </b-nav>
  </span>
</template>
<script>

export default {
  name: 'top-admin-dynamic-group',
  computed: {
    links() {
      return this.$store.getters["getLinksByGroup"]('Administration')
    },
    showNav() {
      return this.$store.getters["getLinksByGroup"]('Administration').length > 0
    },
  },
}
</script>
